"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TokenServiceInterface_1 = require("../../BusinessLogicLayer/TokenServiceInterface");
const AuthException_1 = __importDefault(require("../../Exception/AuthException"));
class AuthCache {
    constructor(cache) {
        this.unset = async () => {
            return this.cache
                .setObject(TokenServiceInterface_1.CACHE_KEY, null)
                .asPromise();
        };
        this.cache = cache;
    }
    async getAuthData() {
        try {
            return (await this.cache.getObject(TokenServiceInterface_1.CACHE_KEY).asPromise());
        }
        catch (e) {
            throw new AuthException_1.default();
        }
    }
    setAuthData(authData) {
        return this.cache
            .setObject(TokenServiceInterface_1.CACHE_KEY, authData
            ? {
                token: authData.token,
                refreshToken: authData.refreshToken,
                expiresIn: authData.expiresIn,
            }
            : null)
            .asPromise();
    }
}
exports.default = AuthCache;
//# sourceMappingURL=AuthCache.js.map